import { render, staticRenderFns } from "./LinkedInIcon.vue?vue&type=template&id=23fad575&scoped=true&"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js&"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInIcon.vue?vue&type=style&index=0&id=23fad575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fad575",
  null
  
)

export default component.exports